var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01367 7.32422C0.500977 7.32422 0.0908203 6.9209 0.0908203 6.40137V5.63574C0.0908203 3.45508 1.63574 2.12891 4.12402 2.12891H9.23047V0.679688C9.23047 0.255859 9.4834 -0.00390625 9.90039 -0.00390625C10.0986 -0.00390625 10.2559 0.0644531 10.3857 0.173828L13.2432 2.58008C13.5645 2.84668 13.5576 3.27734 13.2432 3.54395L10.3857 5.9502C10.2559 6.05957 10.0986 6.12793 9.90039 6.12793C9.4834 6.12793 9.23047 5.875 9.23047 5.45117V3.92676H4.02832C2.72949 3.92676 1.92969 4.66504 1.92969 5.86816V6.40137C1.92969 6.9209 1.52637 7.32422 1.01367 7.32422ZM14.9863 6.38086C15.499 6.38086 15.9023 6.79102 15.9023 7.30371V8.06934C15.9023 10.25 14.3574 11.5762 11.8691 11.5762H6.76953V13.0254C6.76953 13.4492 6.50977 13.7021 6.09277 13.7021C5.90137 13.7021 5.7373 13.6338 5.60742 13.5244L2.75 11.1182C2.43555 10.8516 2.43555 10.4277 2.75 10.1543L5.60742 7.74805C5.7373 7.63867 5.90137 7.57031 6.09277 7.57031C6.50977 7.57031 6.76953 7.83008 6.76953 8.25391V9.77832H11.9717C13.2637 9.77832 14.0703 9.04004 14.0703 7.83691V7.30371C14.0703 6.79102 14.4736 6.38086 14.9863 6.38086Z",
    fill: "#7B5DF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.b067ad06d5e8c3c42ce3cd955af74e11.svg";
export { ForwardRef as ReactComponent };